import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import {
  FinanceChartData,
  FinanceChartDataRequest,
  FinanceChartDataResponse,
  FinanceChartSummary,
  RangeValue,
} from './types'
import { $params } from '../../../../../features/router'
import { changedDateFormat } from '../../../../../libs/utils'

export const financeChartDataMounted = createEvent<FinanceChartDataRequest>()

export const getFinanceChartData = fx<void, FinanceChartDataResponse>({
  method: 'GET',
  url: '/finance/wallet/{id}/statistics',
})

export const $financeChartData = restore<FinanceChartData[]>(
  getFinanceChartData.doneData.map((a) => a.body.items),
  [],
)

export const $financeChartSummary = restore<FinanceChartSummary>(
  getFinanceChartData.doneData.map((a) => a.body.summary),
  {} as FinanceChartSummary,
)

sample({
  // @ts-ignore
  clock: financeChartDataMounted,
  source: $params,
  fn: (params, { filters }) => {
    let id
    if (params) {
      id = params.walletID
    }

    let query = {}

    let filtersTransactionsParams = {}

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      filtersTransactionsParams = Object.keys(filters).reduce(
        (accumulator, key) => {
          if (filters[key as keyof typeof filters] != null) {
            if (key === 'currency') {
              accumulator[key as keyof typeof filters] =
                filters[key as keyof typeof filters]
            } else if (key === 'period') {
              accumulator['date'] = [
                changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[0].$d,
                ),
                changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[1].$d,
                ),
              ]
            } else {
              accumulator[key as keyof typeof filters] = `${
                filters[key as keyof typeof filters]
              }`
            }
          }

          return accumulator
        },
        {} as any,
      )
    }

    if (Object.keys(filtersTransactionsParams).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(filtersTransactionsParams)}`
    }

    // @ts-ignore
    query['order'] = `date`

    return {
      url: `/finance/wallet/${id}/statistics`,
      query,
    }
  },
  target: getFinanceChartData,
})
